import React, { useContext, useEffect, useRef, useState } from "react";
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, CardText, CardTitle, Col, Row, Spinner, Table} from "reactstrap";
import { GlobalStore } from "../../../StateStores";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { getInspectionChecklists, postInspections } from "../../../Actions/InspectionActs";
import CategoryList from "../InspectionForm/CategoryList";
import ComponentList from "../InspectionForm/ComponentList";
import TroubleshootList from "../InspectionForm/TroubleshootList";
import InspectionReport from "../InspectionReport";


const AssessmentForm = ()=>{
    const Navigate = useNavigate();

    const {InspectionDispatch,InspectionState:{
        getInspections:{error,loading,data},
        postInspections:{error:postError,loading:postLoading,data:postData},
    }} = useContext(GlobalStore);
    const scrollRef = useRef(null);
    const location = useLocation();
    const [formValid, setFormValid] = useState(false);
    const [form,setForm] = useState({component_condition:'',remarks:''});
    const [formErrors,setFormErrors] = useState({
        remarks:'Remarks is required',
        component_condition:'Component condition is required',
    });
    const [inspections, setInspections] = useState([]);
    const [categories, setCategories] = useState([]);
    const [inspectionMaster, setInspectionMaster] = useState({});
    const [inspectionCheckpointReport, setInspectionCheckpointReport] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const { inspection_master_id,route_from,route_to } = location.state || {};

    if(!form.visitno){
        // return <NoVisitSelectedError/>
        //Navigate('/dashboard');
    }

    useEffect(()=>{
        const loadChecklist = async ()=>{
            try {
                const response = await getInspectionChecklists({
                    inspection_id:inspection_master_id
                })(InspectionDispatch)
                const {checklist,master,checkpoint_report} = response.data;
                
                setCategories(checklist)
                setInspectionMaster(master[0])
                setInspectionCheckpointReport(checkpoint_report)
            } catch (error) {
                
            }
        }
        loadChecklist();
    },[inspection_master_id])

    // console.log(inspectionCheckpointReport)

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setSelectedComponent(null);  // Reset selected component when category changes
    };
    
    const handleComponentSelect = (component) => {

        // Check if the component is already added to the inspections
        const isAlreadyAdded = inspections.some(
            inspection => inspection.component_id === component.id
        );

        if(isAlreadyAdded){
            // Show a Swal warning if the component is already added
            Swal.fire({
                title: component?.component_name,
                text: 'This component has already been added to the inspection list.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });

        }else{
            setSelectedComponent(component);
            setFormErrors({
                remarks:'Remarks is required',
                component_condition:'Component condition is required',
            });
            setForm({ component_condition: '', remarks: '' });
        }
    };

    const onChange = ({name,value}) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault();

        const newInspection = {
            category: selectedCategory.category_name,
            component: selectedComponent.component_name,
            component_id: selectedComponent.id,
            condition: form.component_condition,
            remarks: form.remarks,
        };

        // Check if the component is already added to the inspections
        const isAlreadyAdded = inspections.some(
            inspection => inspection.component_id === selectedComponent.id
        );

        if(isAlreadyAdded){
            
            // Show a Swal warning if the component is already added
            Swal.fire({
                title: selectedComponent?.component_name,
                text: 'This component has already been added to the inspection list.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });

        }else{
            setInspections(prev => [...prev, newInspection]);
            setForm({ component_condition: '', remarks: '' });
            setSelectedComponent(null);
        }
    
    };

    const removeInspection = (component_id)=>{
        setInspections(prev => prev.filter(inspection => inspection.component_id !== component_id));
    }

    const handleSaveToServer = async () => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save checkpoint inspections?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!'
          }).then(async (result) => {

            if (result.isConfirmed) {

                const payload = {
                    route_from:route_from,
                    route_to:route_to,
                    inspection_master_id:inspection_master_id,
                    inspections:inspections
                }

                try {
                    //Consider as new checkpoint, every inspection is from new checkpoint
                    const response = await postInspections(payload)(InspectionDispatch);
                    const {inspection_report_id,message} = response.data
                    if(response.status){
                        toast.success(message);
                        setInspections([])
                    }else{
                        toast.error(message)
                    }
                } catch (error) {
                    toast.error(error?.response?.data?.message || error?.message)
                }

            }

          })

    };
    
    return(
        <React.Fragment>

            <Row className="mt-5">
                <Col md="3">
                    <Card className="mb-1 shadow-sm">
                        <CardBody>
                            <Row>
                                <Col md={3}>
                                    <div className="col-auto">
                                        <div className="avatar-sm">
                                            <img src='/user-dummy-img.jpg' alt="user-img"
                                                className="img-thumbnail rounded-circle" />
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <CardTitle tag="h5">{inspectionMaster?.owner_name}</CardTitle>
                                    <CardText>
                                        <span className="text-capitalize fs-12">{inspectionMaster?.owner_category_desc}</span>, 
                                        {/* <div><small className="text-muted ms-1 fs-12">{inspectionMaster?.owner_address}</small></div> */}
                                    </CardText>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col>
                                    <Table size="sm" className="caption-top">
                                        <tbody>
                                            <tr>
                                                <th>Starting point</th>
                                                <td>{inspectionMaster?.route_from}</td>
                                            </tr>
                                            <tr>
                                                <th>Final destination</th>
                                                <td>{inspectionMaster?.route_to}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{inspectionMaster?.route_remarks}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="9">
                     <Card className="shadow-sm card-animate">
                        <CardHeader tag="div">
                            <span className="ri-truck-line"></span>
                            <span className="ms-1">PROPOSED VEHICLE INSPECTION LOG BOOK</span>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <Table size="sm" className="caption-top">
                                        <caption>Vehicle detail</caption>
                                        <tbody>
                                            <tr>
                                                <th>Reg Number</th>
                                                <td>{inspectionMaster?.registration_number}</td>
                                            </tr>
                                            <tr>
                                                <th>Vehicle make</th>
                                                <td>{inspectionMaster?.make}</td>
                                            </tr>
                                            <tr>
                                                <th>Vehicle class</th>
                                                <td>{inspectionMaster?.motor_usage_desc}</td>
                                            </tr>
                                            <tr>
                                                <th>Number of passengers</th>
                                                <td>N/A</td>
                                            </tr>
                                            <tr>
                                                <th>Cargo type</th>
                                                <td>{inspectionMaster?.body_type}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col>
                                    <Table size="sm" className="caption-top">
                                        <caption>Driver details</caption>
                                        <tbody>
                                            <tr>
                                                <th>Driver name</th>
                                                <td>N/A</td>
                                            </tr>
                                            <tr>
                                                <th>Driving license no</th>
                                                <td>{inspectionMaster?.tdriver}</td>
                                            </tr>
                                            <tr>
                                                <th>Driver's condition</th>
                                                <td>N/A</td>
                                            </tr>
                                            <tr>
                                                <th>Mobile no</th>
                                                <td>N/A</td>
                                            </tr>
                                            <tr>
                                                <th>Pending offiences</th>
                                                <td>N/A</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-sm card-animate">
                        <CardHeader tag="div">
                            <span className="ri-truck-line"></span>
                            <span className="ms-1">PROPOSED VEHICLE INSPECTION LOG BOOK</span>
                        </CardHeader>
                        <CardBody>
                        <Row>
                            <Col xs="3">
                                <h5>System Categories</h5>
                                <CategoryList 
                                    categories={categories} 
                                    onSelectCategory={handleCategorySelect} 
                                    activeCategory={selectedCategory} 
                                />
                            </Col>
                            <Col xs="3">
                                <h5>System Components</h5>
                                {selectedCategory ? (
                                    <ComponentList 
                                    components={selectedCategory.components} 
                                    onSelectComponent={handleComponentSelect} 
                                    activeComponent={selectedComponent}
                                    addedComponentList={inspections} 
                                    />
                                ) : (
                                    <p>Select a category to see components</p>
                                )}
                            </Col>
                            <Col xs="6">
                                <h5>Troubleshoots</h5>
                                {selectedComponent ? (
                                    <TroubleshootList 
                                    troubleshoots={selectedComponent.troubleshoots} 
                                    componentName={selectedComponent.component_name}
                                    componentId={selectedComponent.id}
                                    form={form}
                                    onChange={onChange}
                                    onSubmit={handleSubmit}
                                    formErrors={formErrors}
                                    />
                                ) : (
                                    <p>Select a component to see troubleshoots and enter a report</p>
                                )}
                            </Col>
                        </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Card className="shadow-sm card-animate">
                <CardBody>
                    <Table bordered size="sm" className="caption-top">
                        <caption>INSPECTION CHECK  POINT SELECTED COMPONENT</caption>
                        <thead className="bg-light">
                            <tr>
                                <th>SN</th>
                                <th>Category</th>
                                <th>Component</th>
                                <th>Condition</th>
                                <th>Remarks</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(inspections || []).map((inspection,index)=>(
                                <tr key={index}>
                                    <td>{++index}</td>
                                    <td>{inspection.category}</td>
                                    <td>{inspection.component}</td>
                                    <td>{inspection.condition}</td>
                                    <td>{inspection.remarks}</td>
                                    <td style={{width:'20px'}}>
                                        <Button 
                                            size="sm" 
                                            color="danger"
                                            onClick={()=>removeInspection(inspection.component_id)}
                                            >
                                            <span className="ri-delete-bin-line"></span>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </CardBody>
                <CardFooter className="p-1 bg-light">
                    <div className="hstack gap-2 justify-content-end d-print-none">
                        <Button 
                            onClick={handleSaveToServer}
                            disabled={inspections.length === 0}
                            type="submit" 
                            className='btn btn-sm'>
                                {postLoading && <Spinner size="sm"/>}
                                {!postLoading && <i className="ri-save-line align-bottom me-1"></i>} Save All Inspections
                            </Button>
                    </div>
                </CardFooter>
            </Card>

            <InspectionReport data={inspectionCheckpointReport}/>
        </React.Fragment>
    )
}

export default AssessmentForm;